import { C } from '../../lib/theme';
import { styles } from '../../lib/styles';
import { $ } from '../../lib/util';
import { Dialog } from '../Dialog';
import { useAppData } from '../../state/contexts/AppDataContext';
import { useUIState } from '../../state/contexts/UIStateContext';
import { useDisputeActions } from '../../state/actions/disputes';

export function NewIpDisputeModal() {
  const { cases } = useAppData();
  const { setModal } = useUIState();
  const { createIpDisputeForCase } = useDisputeActions();
  return (
    <Dialog title="File IP Infringement Claim" onClose={() => setModal(null)}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
          <div>
            <label htmlFor="ip-case" style={{ fontSize: 11, color: C.textMuted }}>Related Case</label>
            <select id="ip-case" style={{ ...styles.select, width: '100%' }}>
              {cases.map(c2 => <option key={c2.id} value={c2.id}>{c2.id} — {c2.registrant}</option>)}
            </select>
          </div>
          <div>
            <label htmlFor="ip-type" style={{ fontSize: 11, color: C.textMuted }}>Claim Type</label>
            <select id="ip-type" style={{ ...styles.select, width: '100%' }}>
              <option value="COPYRIGHT">Copyright (DMCA)</option>
              <option value="TRADEMARK">Trademark</option>
            </select>
          </div>
          <div>
            <label htmlFor="ip-claimant" style={{ fontSize: 11, color: C.textMuted }}>Claimant Name</label>
            <input id="ip-claimant" style={styles.input} />
          </div>
          <div>
            <label htmlFor="ip-claimant-email" style={{ fontSize: 11, color: C.textMuted }}>Claimant Email</label>
            <input id="ip-claimant-email" style={styles.input} />
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="ip-details" style={{ fontSize: 11, color: C.textMuted }}>Claim Details</label>
          <textarea id="ip-details" style={styles.textarea} placeholder="Describe the alleged infringement, including specific content (Call Logo, Display Name, Call Reason), dates, TNs, and registration info if trademark..." />
        </div>
        <div style={{ fontSize: 11, color: C.warn, marginBottom: 16 }}>⚠ Upon filing: Registrant must be notified within 24hrs · Infringing content suspended from Settlement Platform within 24hrs</div>
        <div style={{ display: 'flex', gap: 12 }}>
          <button style={{ ...styles.btn, ...styles.btnGold }} onClick={() => {
            const caseId = $('ip-case').value;
            const type = $('ip-type').value;
            const claimantName = $('ip-claimant').value;
            const claimDetails = $('ip-details').value;
            if (claimantName && claimDetails) { createIpDisputeForCase(caseId, type, claimantName, claimDetails); setModal(null); }
          }}>File Claim</button>
          <button style={{ ...styles.btn, ...styles.btnOutline }} onClick={() => setModal(null)}>Cancel</button>
        </div>
    </Dialog>
  );
}
